import { render } from "./TypeDocForm.vue?vue&type=template&id=44e054fc&scoped=true"
import script from "./TypeDocForm.vue?vue&type=script&lang=js"
export * from "./TypeDocForm.vue?vue&type=script&lang=js"

import "./TypeDocForm.vue?vue&type=style&index=0&id=44e054fc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e054fc"]])

export default __exports__